export const environment = {
  isProduction: true,
  wsUrl: 'https://api-staging.grikocnavigasyon.com'
};
